import { useMutation } from 'react-query'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { UseMutationOptions } from 'react-query/types/react/types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { workspacesSet } from 'redux/actions'
import { useDispatch } from 'react-redux'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { useIntercomEvent } from 'hooks/useIntercomEvent'

export interface Options extends Omit<UseMutationOptions, 'mutationFn'> {}

export const useCompleteVMOnboarding = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const workspaces = useWorkspaces()
  const dispatch = useDispatch()
  const trackIntercomEvent = useIntercomEvent()

  return useMutation(() => WorkspaceClient.completeVirtualMarketerOnboarding(currentWorkspaceId), {
    onSuccess: () => {
      dispatch(
        workspacesSet(
          workspaces.map((ws) =>
            ws.id === currentWorkspaceId
              ? {
                  ...ws,
                  is_virtual_marketer_onboarding_completed: true,
                  virtual_marketer_onboarding_completed_at: new Date().toISOString(),
                }
              : ws,
          ),
        ),
      )
      trackIntercomEvent('virtual_marketer_onboarding_completed')
    },
  })
}
